/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import { ObjectUtil } from "src/utils";
import AddressDTO from "./AddressDTO";
import InterpretingServiceRequest from "./InterpretingServiceRequest";
import LanguageProficiencyRequest from "./LanguageProficiencyRequest";
import moment from "moment";


interface AdminAddUpdateUserRequest {
  emailAddress: string;
  password: string;
  phoneNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  discriminator: number | null;
  gender: string;
  /** Not currently used! */
  twoFactorId: number | null;
  roleId: number | null;
  isApproved: boolean | null;
  isActive: boolean | null;
  dateOfBirth: moment.Moment | null;
  profilePictureUrl: string;
  currentAddress: AddressDTO | null;
  mailingAddress: AddressDTO | null;
  interpretingServices: InterpretingServiceRequest[];
  /** Proficiency is a language and level, so we need more than just an ID */
  languageProficiencies: LanguageProficiencyRequest[];
}
const AdminAddUpdateUserRequest = {
  create: (initValues?: Partial<AdminAddUpdateUserRequest> | null): AdminAddUpdateUserRequest => {
    const defaults: AdminAddUpdateUserRequest = {
      emailAddress: "",
      password: "",
      phoneNumber: "",
      firstName: "",
      middleName: "",
      lastName: "",
      discriminator: null,
      gender: "",
      twoFactorId: null,
      roleId: null,
      isApproved: null,
      isActive: null,
      dateOfBirth: null,
      profilePictureUrl: "",
      currentAddress: null,
      mailingAddress: null,
      interpretingServices: [],
      languageProficiencies: [],
    };
    const fixedValues: Partial<AdminAddUpdateUserRequest> = initValues != null
      ? {
        dateOfBirth: initValues.dateOfBirth != null ? ObjectUtil.ToMoment(initValues.dateOfBirth) : null,
        currentAddress: initValues.currentAddress != null ? AddressDTO.create(initValues.currentAddress) : null,
        mailingAddress: initValues.mailingAddress != null ? AddressDTO.create(initValues.mailingAddress) : null,
        interpretingServices: (initValues.interpretingServices ?? []).map(InterpretingServiceRequest.create) as InterpretingServiceRequest[],
        languageProficiencies: (initValues.languageProficiencies ?? []).map(LanguageProficiencyRequest.create) as LanguageProficiencyRequest[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AdminAddUpdateUserRequest;
